import * as FullscreenDialog from './components/FullscreenDialog.css';
export default {
    FullscreenDialog
};
